import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  translatedContent!: string;
  displayAboutDialog: boolean = false;
  constructor(private translate: TranslateService) {} 
  
  openDialog(){
    this.translatedContent = this.translate.instant('MAP.ABOUT.CONTENT3');
    this.displayAboutDialog = true;
  }

  hideDialog(){
    this.displayAboutDialog = false;
  }
}
